import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {FITHGameConfig} from "../FITHGameConfig";
import {FITHParsedGameData} from "../server/data/FITHParsedGameData";
import {FITHGameMode} from "../gameMode/FITHGameMode";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {FITHParsedInitData} from "../server/data/FITHParsedInitData";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {FITHGameModuleConfig} from "../FITHGameModuleConfig";
import {FITHSoundManager} from "../sound/FITHSoundManager";
import {FITHSoundConfig} from "../FITHSoundConfig";

export class FITHAnticipationController extends ReelStopPresentationController {
    private _allScatters: StateReelSymbol[] = [];
    private _mode: string;
    private _nextMode: string;
    private _reelsAfterCollapse: string[][];
    private _activeRowsAfter: number;
    private _activeReels: number[] = [0, 1, 2, 3, 4, 5];
    private _anticipationStartId: number;
    private _allReelsStopped: boolean = true;
    private _anticipationPlaying: boolean = false;
    private _totalReels: number = FITHGameConfig.instance.REELS_NUM_ORIGINAL;
    private _symLandingWoodSoundPlayed: boolean = false;
    private _scatterLandsSoundPlayed: boolean = false;
    private _scatterWinSoundPlayed: boolean = false;
    private _wasFeatureBuy: boolean = false;

    public onReelStopSymbolAttention(data: IReelStoppedData): void {
        if (this._mode === FITHGameMode.BONUS) {
            return;
        }

        const symbol: StateReelSymbol = data.symbols![0];
        if (symbol.symName !== ReelSymbolName.BONUS) {
            // #209
            if ((!this._anticipationPlaying || data.quickStop) && this._mode === FITHGameMode.NORMAL_AVALANCHE && !this._symLandingWoodSoundPlayed) {
                this._symLandingWoodSoundPlayed = true;
                FITHSoundManager.playSymLandingWood();
            }

            return;
        }

        // ignore if old scatter drop in avalanche.
        if (this._allScatters.indexOf(symbol) > -1) {
            return;
        }

        // Normal mode
        this._allScatters.push(symbol);

        // #227
        if ((!this._anticipationPlaying || data.quickStop || this._wasFeatureBuy) && !this._scatterLandsSoundPlayed) {
            this._scatterLandsSoundPlayed = true;
            FITHSoundManager.playScatterLands();
        }

        const reelsLeft: number = (this._activeReels.length - data.reelId);
        if (this._allScatters.length + reelsLeft < 3) {
            return; // No chance to win.
        }

        if (this._allScatters.length === 2) {
            for (let i: number = 0; i < this._allScatters.length; i++) {
                if (this._allScatters[i].reelId === (this._totalReels - 1) && this._mode === FITHGameMode.NORMAL) {
                    return;
                }
            }
        }

        if (this._allScatters.length > 2 && (data.quickStop || this._wasFeatureBuy) && !this._scatterWinSoundPlayed) {
            this._scatterWinSoundPlayed = true;
            FITHSoundManager.playScatterWin();
        }

        switch (this._allScatters.length) {
            case 1:
                // do nothing
                return;
            case 2:
                if (!data.quickStop) {
                    this.playAnticipation(this._allScatters[1].reelId + 1);
                }
                return;
            // #166
            case 5:
                const sym: StateReelSymbol = this._allScatters[4];
                if (!data.quickStop && !this._wasFeatureBuy) {
                    FITHSoundManager.playScatterLands();
                    FITHSoundManager.playScatterWin();

                    const x: number = (sym.position.x + sym.parent.x),
                        y: number = (sym.position.y + sym.parent.parent.parent.y);

                    FITHGameModuleConfig.anticipationView.playBWinAnimation(5, x, y);
                }
                FITHGameModuleConfig.anticipationView.doBonusBling(sym);
                this.stopAnticipation();
                return;
            default:
                if (!data.quickStop && !this._wasFeatureBuy) {
                    const scatterLength: number = this._allScatters.length,
                        sym: StateReelSymbol = this._allScatters[scatterLength - 1],
                        x: number = (sym.position.x + sym.parent.x),
                        y: number = (sym.position.y + sym.parent.parent.parent.y);

                    FITHGameModuleConfig.anticipationView.playBWinAnimation(this._allScatters.length, x, y);
                }

                this._allScatters.forEach((scatter: StateReelSymbol) => {
                    FITHGameModuleConfig.anticipationView.doBonusBling(scatter);
                });
        }
    }

    public onReelSpinStopped(data: IReelStoppedData): void {
        super.onReelSpinStopped && super.onReelSpinStopped(data);

        if (this._mode === FITHGameMode.BONUS) {
            this.dispatchCompleteEvent(data.reelId);

            return; // don't work for bonus mode.
        }

        if (data.reelId === this._totalReels - 1) {
            // block it from finished and wait for all complete.
            return;
        }

        // #166
        if (this._anticipationPlaying && this._allScatters.length > 4) {
            this.stopAnticipation();
        }

        const idx: number = this._activeReels.indexOf(data.reelId);
        if (this._anticipationPlaying && (data.reelId >= this._anticipationStartId) && (idx > -1) && (idx < (this._activeReels.length - 1))) {
            FITHGameModuleConfig.anticipationView.updateAnticipationCurrentReel(this._activeReels[idx + 1]);
        }

        this.dispatchCompleteEvent(data.reelId);
    }

    protected resetFeature(): void {
        if (this._nextMode === FITHGameMode.BONUS) {
            return;
        }

        this._activeReels = [0, 1, 2, 3, 4, 5];
        this._allReelsStopped = false;

        // so that it goes out of total reels and the condition never comes out to be true, which we check in onReelSpinStopped method to update the current reel anticipation animation.
        this._anticipationStartId = this._totalReels;

        if (this._nextMode === FITHGameMode.NORMAL) {
            this._allScatters = [];
            return;
        }

        // normal avalanche
        this._activeReels = [];
        this._reelsAfterCollapse.forEach((reel: string[], reelId: number) => {
            // Restore state
            if (this._activeRowsAfter !== 6) {
                reel = reel.slice(0, this._activeRowsAfter);
            }
            if (reel.indexOf("X") > -1) {
                this._activeReels.push(reelId);
            }
        });

        if (this._allScatters.length >= 2 && this._allScatters.length < 5) {
            this.playAnticipation(this._activeReels[0]);
        }
    }

    protected addFeatureEventHandlers(): void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_RESTORE, () => this.onRestore());
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_ANIMATION_STOPPED, () => this.onAllReelsSpinAnimationStopped());
    }

    protected parseFeatureGameData(data: FITHParsedGameData) {
        super.parseFeatureGameData && super.parseFeatureGameData(data);

        this.onDataParsed(data);
        this._wasFeatureBuy = data.wasFeatureBuy;
    }

    private onInitDataParsed(data: FITHParsedInitData): void {
        this.onDataParsed(data);

        EventHandler.removeEventListener(this, ServerEvent.INIT_DATA_PARSED);
    }

    private onDataParsed(data: FITHParsedInitData | FITHParsedGameData): void {
        this._mode = data.mode;
        this._nextMode = data.nextMode;
        this._activeRowsAfter = ((data instanceof FITHParsedGameData) ? data.baseActiveRowsAfter : data.activeRows);
        this._reelsAfterCollapse = data.reelsAfterCollapse.slice(0, this._totalReels);
    }

    private onRestore(): void {
        if (this._mode === FITHGameMode.BONUS) {
            return;
        }

        this._allScatters = [];
        this._reelsAfterCollapse.forEach((reel: string[], reelId: number) => {
            reel.forEach((symbolName: string, symId: number) => {
                if (symbolName === ReelSymbolName.BONUS) { // No need to think about winPositions here?
                    const symbol: StateReelSymbol = Reels.getSymbol(reelId, symId)!;
                    if (symbol === null || symbol.symName !== ReelSymbolName.BONUS) {
                        debugger;
                    }
                    // doing state change so that bling can work on the scatter symbol.
                    symbol.changeState({
                        state: FITHGameConfig.instance.SYMBOL_STATES.land
                    });
                    
                    this._allScatters.push(symbol);
                }
            });
        });
    }

    private onAllReelsSpinAnimationStopped(): void {
        this._allReelsStopped = true;
        this.stopAnticipation();
        this.onAnimationComplete();
    }

    private playAnticipation(reelId: number): void {
        if (this._anticipationPlaying || this._wasFeatureBuy) {
            return;
        }

        // #227
        FITHSoundManager.playScatterAnticipation();

        FITHGameModuleConfig.background.toggleBgOverlay(true, 0.6);
        FITHGameModuleConfig.anticipationView.playAnticipation(reelId);
        this._allScatters.forEach((scatter: StateReelSymbol) => {
            FITHGameModuleConfig.anticipationView.doBonusBling(scatter);
        });

        this._anticipationPlaying = true;
        this._anticipationStartId = reelId;
    }

    private stopAnticipation(): void {
        if (!this._anticipationPlaying) {
            return;
        }

        // #227
        FITHSoundManager.stopSoundEffect(FITHSoundConfig.instance.SCATTER_ANTICIPATION, 200);

        // #273
        if (this._allScatters.length === 2) {
            FITHSoundManager.playScatterAnticipationFail();
        }

        FITHGameModuleConfig.background.toggleBgOverlay(false, 0);
        FITHGameModuleConfig.anticipationView.stopAnticipation();

        this.clearAllScatters();

        this._anticipationPlaying = false;
    }

    private onAnimationComplete(): void {
        if (!this._allReelsStopped) {
            return;
        }

        this.dispatchCompleteEvent(this._totalReels - 1);

        this._symLandingWoodSoundPlayed = false;
        this._scatterLandsSoundPlayed = false;
        this._scatterWinSoundPlayed = false;

        // #266
        if (this._nextMode !== FITHGameMode.NORMAL_AVALANCHE) {
            this.clearAllScatters();
        }
    }

    private clearAllScatters(): void {
        this._allScatters.forEach((scatter: StateReelSymbol) => {
            // #281
            if (scatter.children.length > 2) {
                let blingChild: PIXI.DisplayObject | undefined | null = scatter.children.pop();
                if (blingChild) {
                    blingChild = null; // marking it for garbage collection.
                }
            }
        });
    }
}